export enum DiscountType {
  GLOBAL = "GLOBAL",
  CUSTOM = "CUSTOM",
  MEMBERSHIP = "MEMBERSHIP",
  PACKAGE = "PACKAGE",
  SAVED_ITEM = "SAVED_ITEM",
  PROMOTION = "PROMOTION",
  // Written by the server when cash is rounded to the nearest $0.05. Signed:
  // negative when the patient paid the extra cents.
  CASH_ROUNDING = "CASH_ROUNDING",
}

/** How a fixed-amount discount is applied across matching cart items. */
export enum DiscountAmountScope {
  /** Apply the amount once, off the transaction total (default for fixed amounts). */
  TRANSACTION = "TRANSACTION",
  /** Apply the amount to each matching item/unit. */
  PER_ITEM = "PER_ITEM",
}
